import Request from '../../../../src/core/gd/data/request'
import {SessionMissingData} from "../../gd-session/@type";

export default class ApiSession {

    public publicKey: string = '' // exists in shared view api

    constructor() {

    }

    // static fullResetV2(companyId: ID | null = null, requestResourceType: string | null = null, requestResourceId: ID | null = null, processSessionResponse: boolean = true) {
    //     return new Request(this,'GET','session/reset',{
    //         companyId, requestResourceType, requestResourceId
    //     },processSessionResponse, true);
    // }

    // new version that usd new (compact) format for
    static fullResetWeb(requestResourceType: string | null = null, requestResourceId: ID | null = null, processSessionResponse: boolean = true) {
        return new Request(this,'GET','session/reset-web',{requestResourceType, requestResourceId}, processSessionResponse, true);
    }

    // deprecated - can be used by MS Teams widget, but it is not released yet, and mb by mobile app
    static fullReset(companyId: ID | null = null, requestResourceType: string | null = null, requestResourceId: ID | null = null, processSessionResponse: boolean = true) {
        return new Request(this,'GET','session/reset',{
            companyId, requestResourceType, requestResourceId
        },processSessionResponse, true);
    }

    loadOlderCompanyAndPersonalEvents(companyId:ID, startMoment:Moment, endMoment:Moment) {
        return new Request(this, 'GET', 'session/events', {
            startDate: startMoment.format('YYYY-MM-DD'),
            endDate: endMoment.format('YYYY-MM-DD'),
        });
    }

    /*getForPrintToPdf(companyId:ID, userId:ID) {
        return new Request(this, 'GET', 'export-pdf/session', { companyId, userId });
    }*/

    resetMeetings() {
        return new Request(this, 'GET', 'session/reset-meetings');
    }

    resetReminders() {
        return new Request(this, 'GET', 'reminders/session-reset');
    }

    resetNoteTypes() {
        return new Request(this, 'GET', 'session/reset-notes');
    }

    resetTodoListTemplates() {
        return new Request(this, 'GET', 'session/todo-list-templates');
    }

    static assignedPlanningV2() {
        return new Request(this, 'GET', 'session/assigned/planning');
    }

    assignedPlanning() {
        return new Request(this, 'GET', 'session/assigned/planning');
    }

    // assignedResetAll() {
    //     return new Request(this, 'GET', 'session/assigned/reset');
    // }

    getMissingData(dataToLoad:SessionMissingData) {

        // New version - in future need to deal with it
        if (dataToLoad.projects) {
            dataToLoad.projectIds = dataToLoad.projects
            delete dataToLoad.projects
        }

        if (dataToLoad.projectsWithParents) {
            dataToLoad.projectsWithParentsIds = dataToLoad.projectsWithParents
            delete dataToLoad.projectsWithParents
        }

        return new Request(this, 'POST', 'session', dataToLoad);
    }

    resetMissing(params:any) {
        return new Request(this, 'POST', 'session/reset-missing', params);
    }
}
